import BaseOption from "@/app/components/common-filter-builder/common-filters-components/base-checkbox/BaseOption";
import PriceQuantity, {
  QuantityContor,
} from "@/app/components/common-filter-builder/common-filters-components/base-checkbox/PriceQuantity";
import NextImage from "@/app/components/lib/NextImage";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  is_multi_select: boolean;
  url: string;
  value: number;
  label: string;
  disabled?: boolean;
  quantityContor?: QuantityContor;
  outOfStock?: boolean;
  disableRemoveAddon?: boolean;
}

const OneCardOption: React.FC<Props> = ({
  label,
  url,
  selected,
  toggleOption,
  is_multi_select,
  value,
  disabled = false,
  quantityContor,
  outOfStock,
  disableRemoveAddon,
}) => {
  const isDisabled =
    (disabled && !selected) || outOfStock || disableRemoveAddon;
  const disabledAndChecked = selected && disableRemoveAddon;
  return (
    <div
      onClick={
        selected && !disableRemoveAddon
          ? quantityContor
            ? (e) => e.stopPropagation()
            : toggleOption
          : !isDisabled
          ? toggleOption
          : undefined
      }
      className={`product-add-on ${selected ? "checked" : ""}`}
      style={
        isDisabled
          ? {
              opacity: 0.8,
              cursor: "not-allowed",
            }
          : undefined
      }
    >
      <div className="add-on-image">
        <NextImage alt="" src={url} objectFit="fill" />
      </div>
      <BaseOption
        selected={selected}
        toggleOption={
          selected && quantityContor && !disableRemoveAddon
            ? toggleOption
            : () => {}
        }
        is_multi_select={is_multi_select}
        label={label}
        disabled={isDisabled}
        disabledAndChecked={disabledAndChecked}
      />
      <div className="add-on-price">
        <PriceQuantity
          price={value}
          quantityContor={quantityContor}
          checked={selected}
          flexColumn
          outOfStock={outOfStock!}
          disabled={disabledAndChecked}
          is_multi_select={is_multi_select}
        />
      </div>
    </div>
  );
};

export default OneCardOption;
